module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Edit-748cbdf481807abd2005ae9f665877d4f2a7dc0694ea175631b386a59fa4d509.svg";